<template>
  <div>
    <div tabindex="0" @focus="focusLast" class="hidden" />
    <div tabindex="-1" ref="first" class="hidden" />
    <slot />
    <div tabindex="-1" ref="last" class="hidden" />
    <div tabindex="0" @focus="focusFirst" class="hidden" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      originalFocus: null
    };
  },
  props: {
    disabled: Boolean
  },
  mounted() {
    this.handleDisabled();
  },
  destroyed() {
    this.disable();
  },
  methods: {
    getFocusedElement() {
      return document.activeElement;
    },
    focusFirst() {
      this.$refs.first.focus({ preventScroll: true });
    },
    focusLast() {
      this.$refs.last.focus({ preventScroll: true });
    },
    enable() {
      this.originalFocus = document.activeElement;
      this.focusFirst();
    },
    disable() {
      this.originalFocus?.focus({ preventScroll: true });
    },
    handleDisabled() {
      if (this.disabled) {
        this.disable();
      } else {
        this.enable();
      }
    }
  },
  watch: {
    disabled() {
      this.handleDisabled();
    }
  }
};
</script>

<style scoped lang="scss">
.hidden {
  outline: none;
}
</style>
